// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Pq-z","slideIn":"Qq-z"};